import { useContext } from 'react';
import { BlockchainServiceContext } from '../context/blockchain-service';
export const useBlockchainService = () => {
    const context = useContext(BlockchainServiceContext);
    if (!context) {
        throw new Error('useBlockchainService must be used within a BlockchainServiceProvider');
    }
    return context.blockchainService;
};
//# sourceMappingURL=blockchain-service.js.map